/**
 *  设置cookie
 *  @public
 *  @param  _asKey cookie的key值
 *          _asValue cookie的value
 *          _anDays cookie的过期时间，是以天为单位。
 *  @return null
 *  @example
 *  cookie_set('signkey','test',1); //设置一天
 *
 */
export function cookie_set(_asKey, _asValue, _anDays, _asDomain, _asPath) {
    var _nDays = _anDays || 30,
        _oExp = new Date(),
        _domain = _asDomain || 'game.weixin.qq.com',
        _path = _asPath || '/';
    _oExp.setTime(_oExp.getTime() + _nDays * 24 * 60 * 60 * 1000);
    document.cookie = _asKey + "=" + escape(_asValue) + ";expires=" + _oExp.toGMTString() + ";domain=" + _domain + ";path=" + _path;
}
/**
 *  读取cookie
 *  @public
 *  @param  _asName cookie的key值
 *  @return 返回_asName对应的cookie
 *  @example
 *  cookie_set('signkey','test',1); //设置一天
 *
 */
export function cookie_get(_asName) {
    var _oRegExp = (new RegExp(["(^|;|\\s+)", (_asName).replace(/([\^\.\[\$\(\)\|\*\+\?\{\\])/ig, "\\$1"), "=([^;]*);?"].join("")));
    if (_oRegExp.test(document.cookie)) {
        try {
            return decodeURIComponent(RegExp["$2"]);
        } catch (e) {
            return RegExp["$2"];
        }
    }
}

export default {
    cookie_set:cookie_set,
    cookie_get:cookie_get
};